import { render } from "./custom-table.vue?vue&type=template&id=6b090834"
import script from "./custom-table.vue?vue&type=script&lang=js"
export * from "./custom-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__